"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));

var _constants = require("../../constants");

var _AccordionDetails = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));

var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _clsx = _interopRequireDefault(require("clsx"));

var _CheckboxSelected = _interopRequireDefault(require("../../assets/img/CheckboxSelected"));

var _CheckboxDefault = _interopRequireDefault(require("../../assets/img/CheckboxDefault"));

var _RadioButtonSelected = _interopRequireDefault(require("../../assets/img/RadioButtonSelected"));

var _utils = _interopRequireDefault(require("../../utils"));

var _TooltipForTruncatedText = _interopRequireDefault(require("../TooltipForTruncatedText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const StyledList = (0, _core.withStyles)(() => ({
  root: {
    '& :not(:last-child) .MuiListItem-root': {
      borderBottom: `1px solid ${_constants.colours.activeFilter}`
    },
    '& .activeCheckbox': {
      backgroundColor: _constants.colours.multiSelect,
      color: _constants.colours.white,
      '& .MuiListItemText-primary': {
        fontSize: _constants.fontSizes.subtitle4,
        fontFamily: _constants.fonts.bold,
        lineHeight: 1.3
      },
      '& .MuiListItemText-secondary': {
        color: _constants.colours.white,
        fontSize: _constants.fontSizes.subtitle4,
        opacity: 0.8
      },
      '& .MuiListItemText-secondary > span': {
        color: _constants.colours.white
      },
      '& .MuiListItemText-secondary > span.thirdText': {
        fontSize: _constants.fontSizes.subtitle2
      },
      '& .MuiListItemText-primary .MuiTypography-noWrap': {
        fontFamily: _constants.fonts.bold,
        fontSize: _constants.fontSizes.subtitle4,
        lineHeight: 1.3
      },
      '& .childItem .MuiListItemText-primary .MuiTypography-noWrap': {
        fontFamily: _constants.fonts.normal
      },
      '& .MuiListItemText-secondary .MuiTypography-noWrap': {
        fontFamily: _constants.fonts.normal,
        fontSize: _constants.fontSizes.subtitle2
      }
    },
    '& .regularCheckbox': {
      fontSize: _constants.fontSizes.subtitle2,
      color: _constants.colours.font,
      '& .MuiListItemText-primary': {
        fontSize: _constants.fontSizes.subtitle4,
        fontFamily: _constants.fonts.bold
      },
      '& .MuiListItemText-primary .MuiTypography-noWrap': {
        fontFamily: _constants.fonts.bold,
        fontSize: _constants.fontSizes.subtitle4,
        lineHeight: 1.3
      },
      '& .MuiListItemText-secondary .MuiTypography-noWrap': {
        fontFamily: _constants.fonts.normal,
        fontSize: _constants.fontSizes.subtitle2
      },
      '& .childItem .MuiListItemText-primary .MuiTypography-noWrap ': {
        fontFamily: _constants.fonts.normal
      },
      '& .MuiListItemText-secondary': {
        fontSize: _constants.fontSizes.subtitle4
      },
      '& .MuiListItemText-secondary > span.thirdText': {
        fontSize: _constants.fontSizes.subtitle2
      }
    },
    '& .highlighted': {
      color: _constants.colours.red
    },
    '& .MuiListItemSecondaryAction-root': {
      fontFamily: _constants.fonts.bold,
      fontSize: _constants.fontSizes.subtitle2,
      '& .isHighlighted': {
        color: _constants.colours.white
      }
    },
    '& .thirdText': {
      fontSize: `${_constants.fontSizes.subtitle4}!important`,
      color: _constants.colours.darkGrey,
      fontWeight: 'bold'
    },
    '& .MuiListItemAvatar-root': {
      minWidth: 46
    },
    '& .MuiAvatar-root': {
      width: 32,
      height: 32,
      border: `2px solid ${_constants.colours.mediumGrey}`
    },
    '& .MuiFormControlLabel-root': {
      marginRight: 0
    },
    '& .customAccordionWrapper': {
      boxShadow: 'none',
      padding: 0,
      borderRadius: 0
    },
    '&.MuiList-dense .MuiAccordion-root': {
      border: '0!important'
    },
    '&.MuiList-dense .MuiAccordionSummary-expandIcon': {
      padding: 0
    },
    '&.MuiList-dense .MuiAccordionSummary-content': {
      border: '0!important'
    }
  }
}))(_core.List);
const StyledListItem = (0, _core.withStyles)(() => ({
  root: {
    height: 60,
    '&.threeLines': {
      height: 78
    },
    '&.highlightParent': {
      backgroundColor: _constants.colours.highlightBlue,
      color: _constants.colours.black
    },
    '&.highlightInactive': {
      backgroundColor: _constants.colours.lightGrey,
      color: _constants.colours.black
    },
    padding: '14px 20px',
    '& .MuiTypography-noWrap': {
      marginRight: 'calc(100% - 75%)',
      display: 'block'
    },
    '&.MuiListItem-dense': {
      height: 'auto',
      padding: '0 16px',
      border: '0!important'
    },
    '& .MuiListItemSecondaryAction-root': {
      fontFamily: _constants.fonts.normal,
      fontSize: _constants.fontSizes.subtitle4
    },
    '& .childItem': {
      paddingLeft: 15
    },
    '& .parentItem .MuiListItemText-primary': {
      fontSize: _constants.fontSizes.subtitle2,
      fontFamily: _constants.fonts.bold
    },
    '& .parentItem.collapsible > .MuiListItemText-secondary': {
      marginTop: 25
    }
  },
  container: {
    width: '100%',
    '& .MuiListItemText-primary': {
      fontFamily: _constants.fonts.bold,
      fontSize: _constants.fontSizes.subtitle4
    },
    '& .MuiListItemText-secondary': {
      fontSize: _constants.fontSizes.subtitle2,
      opacity: '.6'
    },
    '& .singleLine:not(.parentItem) .MuiListItemText-primary': {
      fontSize: _constants.fontSizes.subtitle2,
      fontFamily: _constants.fonts.normal
    },
    '& .MuiIconButton-label svg': {
      width: '30px',
      height: '30px',
      marginRight: '-3px'
    },
    '& .Mui-checked .MuiIconButton-label svg': {
      width: '24px',
      height: '24px',
      marginRight: '0'
    }
  }
}))(_core.ListItem);
const StyledRadioButton = (0, _core.withStyles)(() => ({
  root: {
    '& .MuiIconButton-label svg': {
      width: 24,
      height: 24
    }
  }
}))(_core.Radio);

const getRightColElement = (properties, collapsibleList, singleSelectionList, deleteAction, onHandleChange) => {
  if (deleteAction) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "end",
      "aria-label": "delete",
      onClick: event => {
        event.stopPropagation();
        deleteAction(properties);
      }
    }, /*#__PURE__*/_react.default.createElement(_Delete.default, null)));
  }

  if (properties.checkedName && !properties.disabled) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
      label: collapsibleList && !properties.isChild && properties.hasChild ? 'Select All' : '',
      labelPlacement: collapsibleList && !properties.isChild && properties.hasChild ? 'start' : 'end',
      className: properties.checkedVal ? 'isHighlighted' : '',
      control: singleSelectionList ? /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
        value: properties.checkedName,
        onChange: onHandleChange && (event => onHandleChange(properties, event.target.checked)),
        checked: properties.checkedVal,
        control: /*#__PURE__*/_react.default.createElement(StyledRadioButton, {
          name: "",
          checkedIcon: /*#__PURE__*/_react.default.createElement(_RadioButtonSelected.default, {
            width: 24,
            height: 24
          })
        }),
        label: ""
      }) : /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
        checkedIcon: /*#__PURE__*/_react.default.createElement(_CheckboxSelected.default, {
          width: 24,
          height: 24
        }),
        icon: /*#__PURE__*/_react.default.createElement(_CheckboxDefault.default, {
          width: 24,
          height: 24
        }),
        name: properties.checkedName,
        checked: properties.checkedVal,
        onChange: onHandleChange && (event => onHandleChange(properties, event.target.checked))
      })
    }));
  }

  if (properties.value && !properties.disabled) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, properties.value);
  }

  return null;
};

const StyledAccordion = (0, _core.withStyles)({
  root: {
    '&:not(.customAccordion-dense):not(.last)': {
      borderBottom: `1px solid ${_constants.colours.activeFilter}`
    },
    '& .hasList >:last-child .MuiListItem-root': {
      borderBottom: 0
    }
  }
})(_Accordion.default);
const StyledAccordionSummary = (0, _core.withStyles)({
  root: {
    padding: 0,
    minHeight: 'auto',
    '&.Mui-expanded': {
      minHeight: 'auto'
    },
    '& .MuiListItem-root .MuiListItemText-root': {
      position: 'relative',
      minHeight: 24
    },
    '& .MuiListItem-root .MuiListItemText-root .MuiListItemText-primary': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    '& .MuiListItem-root.hasText': {
      borderBottom: 0
    },
    '&:not(.Mui-expanded) .MuiListItem-root': {
      borderBottom: 0
    },
    '&.customAccordionSummary-dense .MuiAccordionSummary-expandIcon': {
      padding: 0
    },
    '&.customAccordionSummary-dense .MuiAccordionSummary-content': {
      borderLeft: 0
    }
  },
  expandIcon: {
    order: 0,
    marginRight: 0 // fix edge="end"

  },
  content: {
    order: 1,
    margin: 0,
    borderLeft: `1px solid ${_constants.colours.activeFilter}`,
    '&.Mui-expanded': {
      margin: 0
    }
  }
})(_AccordionSummary.default);
const StyledAccordionDetails = (0, _core.withStyles)({
  root: {
    padding: 0,
    '&:not(.customAccordionDetails-dense)': {
      marginLeft: 48,
      // width of the expandIcon
      borderLeft: `1px solid ${_constants.colours.activeFilter}`
    },
    '&.hasText': {
      borderRadius: '6px',
      backgroundColor: _constants.colours.mediumGrey,
      padding: '10px 14px',
      margin: '5px 0'
    },
    '&.hasList': {
      flexDirection: 'column'
    }
  }
})(_AccordionDetails.default);

const PlainListItem = ({
  listItem,
  stripedList,
  collapsibleList,
  classes,
  onHandleChange,
  deleteAction,
  index,
  singleSelectionList
}) => {
  const isItemInactive = () => {
    return !listItem.active && (collapsibleList && !listItem.isChild && !listItem.hasChild || collapsibleList && listItem.isChild || !collapsibleList && !singleSelectionList || singleSelectionList);
  };

  return /*#__PURE__*/_react.default.createElement(StyledListItem, {
    disabled: listItem.disabled,
    button: listItem.checkedName !== undefined,
    onClick: onHandleChange && (() => onHandleChange(listItem, !listItem.checkedVal)),
    name: listItem.checkedName,
    checked: listItem.checkedVal,
    className: (0, _clsx.default)({
      showCheckbox: 'checkedVal' in listItem,
      activeCheckbox: listItem.checkedVal,
      regularCheckbox: listItem.checkedVal === false,
      odd: (index + 1) % 2 !== 0,
      even: (index + 1) % 2 === 0,
      highlighted: listItem.highlight,
      hasText: collapsibleList && 'collapsibleContent' in listItem,
      hasList: collapsibleList && !('collapsibleContent' in listItem),
      [classes.stripedItem]: stripedList,
      threeLines: 'thirdText' in listItem || listItem.thirdText === '',
      highlightParent: collapsibleList && !listItem.isChild && listItem.highlightParent && !listItem.checkedVal,
      showInactive: 'active' in listItem,
      highlightInactive: !listItem.checkedVal && !listItem.active && !listItem.hasChild && 'active' in listItem
    })
  }, listItem.avatarUrl && /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, null, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    alt: listItem.avatarAlt,
    src: listItem.avatarUrl
  })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    className: (0, _clsx.default)({
      childItem: 'isChild' in listItem && listItem.isChild,
      parentItem: 'isChild' in listItem && listItem.isChild === false,
      collapsible: collapsibleList,
      singleLine: !('secondary' in listItem) || listItem.secondary === ''
    }),
    primary: /*#__PURE__*/_react.default.createElement(_TooltipForTruncatedText.default, {
      title: listItem.label
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      noWrap: true
    }, listItem.label)),
    secondary: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, listItem.secondary && /*#__PURE__*/_react.default.createElement(_TooltipForTruncatedText.default, {
      title: listItem.secondary
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "span",
      variant: "inherit",
      noWrap: true
    }, 'active' in listItem && !listItem.active ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isItemInactive() && `${listItem.secondary}-Inactive`, collapsibleList && !listItem.isChild && listItem.hasChild && listItem.secondary) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, listItem.secondary))), !listItem.secondary && 'checkedVal' in listItem && 'active' in listItem && isItemInactive() && /*#__PURE__*/_react.default.createElement(_TooltipForTruncatedText.default, {
      title: "inactive"
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "span",
      variant: "inherit",
      noWrap: true
    }, "Inactive")), listItem.thirdText && /*#__PURE__*/_react.default.createElement(_TooltipForTruncatedText.default, {
      title: listItem.thirdText
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "span",
      variant: "inherit",
      noWrap: true,
      classes: {
        root: 'thirdText'
      }
    }, listItem.thirdText)))
  }), getRightColElement(listItem, collapsibleList, singleSelectionList, deleteAction, onHandleChange));
};

const MemoizedListItem = /*#__PURE__*/_react.default.memo(PlainListItem, (oldProps, newProps) => {
  return JSON.stringify(oldProps) === JSON.stringify(newProps);
});

const CustomListItem = ({
  listItem,
  stripedList,
  collapsibleList,
  classes,
  onHandleChange,
  deleteAction,
  index,
  memoize
}) => {
  return memoize ? /*#__PURE__*/_react.default.createElement(MemoizedListItem, {
    listItem: listItem,
    stripedList: stripedList,
    collapsibleList: collapsibleList,
    classes: classes,
    onHandleChange: onHandleChange,
    deleteAction: deleteAction,
    index: index
  }) : /*#__PURE__*/_react.default.createElement(PlainListItem, {
    listItem: listItem,
    stripedList: stripedList,
    collapsibleList: collapsibleList,
    classes: classes,
    onHandleChange: onHandleChange,
    deleteAction: deleteAction,
    index: index
  });
};
/**
 * Restructure the list data based on parent-child relationship
 * (moving the child items into the 'children' array of their parent)
 * @param {array} list
 * @returns {array} List of parent items
 * [{ isChild: false, children: [{ isChild: true, ... }, ...], ... }, ...]
 */


const groupListByParents = list => {
  return list.reduce((groupedList, item) => {
    if (item.isChild === false) {
      // parent
      groupedList.push({ ...item,
        children: []
      });
    } else if (item.isChild) {
      // child
      groupedList[groupedList.length - 1].children.push(item);
    } else {
      // no parent-child relationship
      groupedList.push(item);
    }

    return groupedList;
  }, []);
};

const CustomList = (0, _core.withStyles)({
  stripedItem: {
    borderRadius: 11,
    '&.even': {
      backgroundColor: _constants.colours.listDarkBackground
    },
    '&.regularCheckbox .MuiListItemText-primary': {
      fontFamily: _constants.fonts.normal
    },
    '& .MuiListItemText-primary': {
      fontSize: _constants.fontSizes.subtitle4
    }
  }
})(({
  classes,
  children,
  data,
  deleteAction,
  stripedList,
  onHandleChange,
  collapsibleList,
  singleSelectionList,
  dense,
  memoize,
  ...otherProps
}) => {
  let listItems = data.map(_utils.default.deepCopy); // "expanded" is an object: {[item1.key]: [Bool], [item2.key]: [Bool], ...}

  const [expanded, setExpanded] = (0, _react.useState)(listItems.reduce((defaultState, item) => ({ ...defaultState,
    [item.key]: item.isExpanded
  }), {}));

  const handleExpandItem = (key, isExpanded) => {
    const newExpanded = { ...expanded
    };
    newExpanded[key] = isExpanded;
    setExpanded(newExpanded);
  }; // if the list is collapsible, restructure the "data" so child list items to go under their parent


  if (collapsibleList) {
    listItems = groupListByParents(listItems);
  }

  return /*#__PURE__*/_react.default.createElement(StyledList, _extends({
    dense: dense || stripedList
  }, otherProps), listItems.map((listItem, index) => {
    const isAccordionEnabled = listItem.collapsibleContent || listItem.children && listItem.children.length;

    const CustomListItemWithProps = (_listItem, _index) => {
      return /*#__PURE__*/_react.default.createElement(CustomListItem, {
        listItem: _listItem,
        stripedList: stripedList,
        collapsibleList: collapsibleList,
        classes: classes,
        onHandleChange: onHandleChange,
        deleteAction: deleteAction,
        index: _index,
        singleSelectionList: singleSelectionList,
        memoize: memoize
      });
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      key: listItem.key
    }, collapsibleList ? /*#__PURE__*/_react.default.createElement(StyledAccordion, {
      className: (0, _clsx.default)({
        customAccordionWrapper: true,
        'customAccordion-dense': dense || stripedList,
        last: index === listItems.length - 1
      }),
      expanded: !!expanded[listItem.key],
      onChange: (event, isExpanded) => {
        // if there are checkboxes, the accordion should work only when the expand icon is clicked
        if (isAccordionEnabled && (!listItem.checkedName || event.target.closest('.MuiAccordionSummary-expandIcon'))) {
          handleExpandItem(listItem.key, isExpanded);
        }
      }
    }, /*#__PURE__*/_react.default.createElement(StyledAccordionSummary, {
      className: (0, _clsx.default)({
        'customAccordionSummary-dense': dense || stripedList
      }),
      expandIcon: expanded[listItem.key] ? /*#__PURE__*/_react.default.createElement(_Remove.default, null) : /*#__PURE__*/_react.default.createElement(_Add.default, null),
      IconButtonProps: {
        disabled: !isAccordionEnabled
      },
      "aria-controls": listItem.key
    }, CustomListItemWithProps(listItem, index)), /*#__PURE__*/_react.default.createElement(StyledAccordionDetails, {
      id: listItem.key,
      className: (0, _clsx.default)({
        hasText: 'collapsibleContent' in listItem,
        hasList: !('collapsibleContent' in listItem),
        'customAccordionDetails-dense': dense || stripedList
      })
    }, listItem.children && listItem.children.length ? listItem.children.map((childItem, childIndex) => /*#__PURE__*/_react.default.createElement("div", {
      key: childItem.key
    }, CustomListItemWithProps(childItem, childIndex))) : listItem.collapsibleContent)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, CustomListItemWithProps(listItem, index)));
  }), children);
});
CustomList.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    isChild: _propTypes.default.bool,
    // used for parent-child relationship, if "collapsibleList" is set to true, then child items will be collapsible
    isExpanded: _propTypes.default.bool,
    // if set to true this collapsible list item is expanded by default
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    secondary: _propTypes.default.string,
    thirdText: _propTypes.default.string,
    avatarURL: _propTypes.default.string,
    avatarAlt: _propTypes.default.string,
    checkedName: _propTypes.default.string,
    highlightParent: _propTypes.default.bool,
    highlightInactive: _propTypes.default.bool,
    checkedVal: _propTypes.default.bool,
    hasChild: _propTypes.default.bool,
    // for parent, if he has at least one child, to display 'select all' label on the checkbox
    collapsibleContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]) // if "collapsibleList" is set to true, then this content will be collapsible

  })).isRequired,
  deleteAction: _propTypes.default.func,
  onHandleChange: _propTypes.default.func,
  stripedList: _propTypes.default.bool,
  collapsibleList: _propTypes.default.bool,
  singleSelectionList: _propTypes.default.bool,
  memoize: _propTypes.default.bool
};
CustomList.defaultProps = {
  deleteAction: null,
  onHandleChange: null,
  stripedList: false,
  collapsibleList: false,
  singleSelectionList: false,
  memoize: false
};
var _default = CustomList;
exports.default = _default;